import { render, staticRenderFns } from "./PendingApproval.vue?vue&type=template&id=05b4bc2f&scoped=true&"
import script from "./PendingApproval.vue?vue&type=script&lang=js&"
export * from "./PendingApproval.vue?vue&type=script&lang=js&"
import style0 from "./PendingApproval.vue?vue&type=style&index=0&id=05b4bc2f&prod&lang=scss&scoped=true&"
import style1 from "./PendingApproval.vue?vue&type=style&index=1&id=05b4bc2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4bc2f",
  null
  
)

export default component.exports